import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Button } from '@driftt/tide-core-legacy'
import styles from './style.styl'

import { fetchOAuthCode, fetchOAuthAppInfo } from 'app/modules/externalApp/actions'
import { getAppInfoFailed, getAppCodeFailed, getAppInfo, getAppCode } from 'app/modules/externalApp/selectors'

const Disclaimer = ({ appInfo }) => {
  return (
    <div>
      <div className="oauth-modal-text">{appInfo.name} will be able to do everything that Drift can do:</div>
      <ul className="color-medium-gray" style={{ paddingLeft: 30 }}>
        <li className="oauth-modal-li">Live Chat With Your Customers</li>
        <li className="oauth-modal-li">Send Customers In-App Messages</li>
        <li className="oauth-modal-li">Improve Your Net Promoter Score</li>
      </ul>
    </div>
  )
}

const OAuthConnect = ({ appInfo, handleAuthorize }) => {
  return (
    <div className="oauth-modal-container">
        <div className="oauth-modal-header-container">
          <img src={require('images/svg/oauth-modal-header-toggle.svg')} className="oauth-modal-header-icon" /> 
        </div>
        <div
          className={`${styles.Content} flex-column flex-center`}
          style={{
            maxWidth: "90vw"
          }}>
          <div className="oauth-modal-body-container">
            <div className="oauth-modal-subheader dsg-h3">
              <strong className="oauth-modal-subheader-accent">{appInfo.name}</strong>
              &nbsp;would like access to&nbsp;
              <strong className="oauth-modal-subheader-accent">Drift</strong>
            </div>
            <div>
              { appInfo.description &&
                <div style={{ marginBottom: 45 }}>
                  {appInfo.description}
                </div>
              }
              <Disclaimer appInfo={appInfo}/>
            </div>
            <div className="oauth-modal-button-container">
              <Button type="primary" className="oauth-submit-button" onClick={handleAuthorize}>Authorize</Button>
              <Button type="secondary" className="oauth-submit-button" onClick={() => window.close()}>Cancel</Button>
            </div>
          </div>
        </div>
      </div>
  )
}

const OAuthFailed = () => (
  <div className={`${styles.FailedContent}`}>
    <div className="oauth-failure-container">
      <img src={require('images/svg/dizzy_robot.svg')} className="oauth-failure-icon"/>
      <div className="oauth-failure-text-container">
        <div className="oauth-failure-subheader-text">
          We ran into a server error and weren’t able to find that client ID.
        </div>
        <div className="oauth-failure-body-text">
          Double check your URL and try again.  Still having trouble? &nbsp;
          <span className="oauth-failure-message-accent">Talk to us.</span>
        </div>
        <Button type="secondary" className="oauth-modal-cancel-Button" onClick={() => { window.close() }}>
          Cancel
        </Button>
      </div>
    </div>
  </div>
)

class OAuth extends Component {

  static contextTypes = {
    router: PropTypes.object.isRequired
  }

  constructor(props) {
    super(props)

    this.state = {
      fetchFailed: false
    }
  }

  componentDidMount() {
    const { redirect_uri, client_id } = this.props.location.query

    this.props.actions.fetchOAuthAppInfo({ redirect_uri, client_id })
    this.props.actions.fetchOAuthCode({ redirect_uri, client_id })
  }

  componentWillReceiveProps(nextProps) {
    if (this.fetchOAuthInfoFailed(nextProps.fetchAppCodeFailed, nextProps.fetchAppInfoFailed)) {
      this.setState({ fetchFailed: true })
    }
  }

  shouldRenderConnect = () => {
    const { code, appInfo } = this.props
    return !!code && !!appInfo && !this.state.fetchFailed
  }

  fetchOAuthInfoFailed = (fetchAppCodeFailed, fetchAppInfoFailed) => {
    return (this.props.fetchAppCodeFailed !== fetchAppCodeFailed && !!fetchAppCodeFailed) ||
      (this.props.fetchAppInfoFailed !== fetchAppInfoFailed && !!fetchAppInfoFailed)
  }

  handleAuthorize = () => {
    const oauth_redirect_uri = `${this.props.location.query.redirect_uri}/?code=${this.props.code}`
    window.location.href = oauth_redirect_uri
  }

  render() {
    const { appInfo } = this.props
    const { fetchFailed } = this.state

    return (
      <div>
        { fetchFailed && <OAuthFailed/> }
        { this.shouldRenderConnect() && <OAuthConnect appInfo={appInfo} handleAuthorize={this.handleAuthorize}/> }
      </div>
    )
  }
}


const mapStateToProps = (state, props) => {
  const { client_id } = props.location.query

  return {
    appInfo: getAppInfo(client_id, state),
    code: getAppCode(client_id, state),
    fetchAppInfoFailed: getAppInfoFailed(client_id, state),
    fetchAppCodeFailed: getAppCodeFailed(client_id, state)
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      fetchOAuthCode,
      fetchOAuthAppInfo
    },
    dispatch
  ),
})

export default connect(mapStateToProps, mapDispatchToProps)(OAuth)


// WEBPACK FOOTER //
// ./src/scripts/components/Integration/OAuth/index.js